import React, { useState } from "react";
import {
  DropdownMenuSub,
  DropdownMenuSubTrigger,
} from "../../ui/dropdown-menu";
import PinDashboardSection from "./PinDashboardSection";

const PinDashboardItem = ({ dashboard, msgId }) => {
  const [isDashboardSectionOpen, setIsDashboardSectionOpen] = useState(false);

  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger
        onPointerLeave={(event) => event.preventDefault()}
        onPointerMove={(event) => {
          event.preventDefault();
        }}
        onClick={() => {
          setIsDashboardSectionOpen(true);
        }}
        className="hover:bg-zinc-800 focus:bg-zinc-800 data-[state=open]:bg-zinc-800 "
      >
        {dashboard.label}
      </DropdownMenuSubTrigger>

      {isDashboardSectionOpen && (
        <PinDashboardSection dashboardId={dashboard._id} msgId={msgId} />
      )}
    </DropdownMenuSub>
  );
};

export default PinDashboardItem;
